// ChatbotTriggers - still used by Sierra for message origin tracking
const ChatbotTriggers = Object.freeze({
	FeedbackButton: 'feedbackBtn',
	AddFunds: 'addFunds',
	CancelAccount: 'cancelAccount',
});

export { ChatbotTriggers };
